import React, { MouseEvent } from 'react';
import { TruckManifestStatus } from '../../trucks/trucksUtils';

interface Props {
  count: number;
  type: TruckManifestStatus;
  disabled?: boolean;
  onClick?: (e: MouseEvent) => void;
}

const classes = {
  [TruckManifestStatus.Ready]: '',
  [TruckManifestStatus.Error]: 'fas fa-stack-1x fa-exclamation-triangle text-danger icon-shift',
  [TruckManifestStatus.InProgress]: 'fas fa-stack-1x fa-cog fa-spin text-info icon-shift',
  [TruckManifestStatus.Success]: 'fas fa-stack-1x fa-check-circle text-success icon-shift',
  [TruckManifestStatus.UserActionNeeded]: 'fas fa-stack-1x fa-exclamation-circle text-warning icon-shift-2',
};

const baseIcon = {
  [TruckManifestStatus.Ready]: 'fas fa-stack-2x fa-truck-loading',
  [TruckManifestStatus.Error]: 'fas fa-stack-2x fa-truck',
  [TruckManifestStatus.InProgress]: 'fas fa-stack-2x fa-truck',
  [TruckManifestStatus.Success]: 'fas fa-stack-2x fa-truck',
  [TruckManifestStatus.UserActionNeeded]: 'fas fa-stack-2x fa-user',
};

const titles = {
  [TruckManifestStatus.Ready]: 'Trucks ready to be manifested.',
  [TruckManifestStatus.Error]: 'Trucks with manifest issues.',
  [TruckManifestStatus.InProgress]: 'Trucks being manifested.',
  [TruckManifestStatus.Success]: 'Trucks successfully manifested.',
  [TruckManifestStatus.UserActionNeeded]: 'Trucks with required user action.',
};

// tslint:disable-next-line: variable-name
const TruckCountComponent = function TruckCountComponent(
  { count, type, onClick, disabled }: Props,
) {
  return (
    <h2
      title={titles[type]}
      onClick={onClick}
      style={{
        opacity: disabled === undefined || disabled ? 1 : 0.5,
        cursor: onClick === undefined ? 'default' : 'pointer',
      }}
    >
      {count}&nbsp;
      <span className="fa-stack fa-xs">
        <i className={baseIcon[type]} />
        {
          type !== TruckManifestStatus.Ready &&
          <i
            className={classes[type]}
          />
        }
      </span>
    </h2>
  );
};

export default TruckCountComponent;
